import * as types from "../actions/actionTypes";

const initialState = {
  audits: [],
  list: {
    totalTransactions: 0,
    transactions: [],
  },
  details: {},
  comments: [],
  documents: [],
  defaultSteps: [],
  defaultTasks: [],
  steps: [],
  tasks: [],
  tasksUncompleted: [],
  stepComments: [],
  stepsDocuments: [],
  templates: [],
  names: [],
  cities: [],
  stateProvinces: [],
  countries: [],
  transactionTypes: [],
  transactionTypesCustom: [],
  transactionStatuses: [],
  transactionManagers: [],
  transactionClientManagers: [],
  businessUnits: [],
  transaction: {},
  associatedLeaseEvents: [],
  associatedPreTransaction: [],
  associatedProperties: [],
  allTransactions: [],
  userDefinedFields: [],
  addressDetails: {},
  fileDetails: {},
  transactionFilters: {
    clientId: 0,
    searchKeyword: null,
    category: null,
    pageNumber: 1,
    pageSize: 10,
    filters: { statusId: [] },
    isDeleted: false,
    isAdminView: false,
  },
  transactionPageSize: 10,
  duplicateTransaction:{},
  transactionActivity:[],
  transactionApprovers:[],
  transactionSelectedApprovers:[],
  approvalCardData:{},
  transactionApprovalResponse:[],
  transactionAllApprovalResponse:[],
  transactionApprovalComments:[],
  transactionApprovalDocuments:[],
  transactionUdfs:[],
};

const transactionStatusNameMap = {
  1: "New",
  2: "On track",
  3: "Delayed",
  4: "Cancelled",
  5: "Completed",
};

export default function transactionReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_TRANSACTIONS: {
      const { data } = action.payload;

      return {
        ...state,
        list: data,
        details: {},
        defaultSteps: [],
        defaultTasks: [],
        steps: [],
        tasks: [],
        tasksUncompleted: [],
        stepComments: [],
        stepsDocuments: [],
        associatedLeaseEvents: [],
        associatedPreTransaction: [],
        associatedProperties: [],
      };
    }

    case types.GET_PRE_TRANSACTIONS_LIST: {
      const { data } = action.payload;

      return {
        ...state,
        list: data,
      };
    }

    case types.SET_TRANSACTION_FILTERS: {
      return {
        ...state,
        transactionFilters: action.payload,
      };
    }

    case types.GET_TRANSACTION: {
      const { data } = action.payload;

      return {
        ...state,
        details: data,
      };
    }

    case types.GET_TRANSACTION_UDF: {
      const { data } = action.payload;

      return {
        ...state,
        userDefinedFields: data,
      };
    }

    case types.GET_PRE_TRANSACTION: {
      const { data } = action.payload;

      return {
        ...state,
        details: {
          ...state.details,
          associatedPreTransaction: data,
        },
      };
    }

    case types.GET_TRANSACTION_COMMENTS: {
      const { data } = action.payload;
      return {
        ...state,
        comments: data,
      };
    }

    case types.GET_TRANSACTION_DOCUMENTS: {
      const { data } = action.payload;
      return {
        ...state,
        documents: data,
      };
    }

    case types.GET_TRANSACTION_DOCUMENT_URL: {
      const { data } = action.payload;

      return {
        ...state,
        fileDetails: { filePath: data },
      };
    }

    case types.GET_TRANSACTION_DEFAULT_STEPS: {
      const { data } = action.payload;

      return {
        ...state,
        defaultSteps: data,
      };
    }

    case types.GET_TRANSACTION_DEFAULT_TASKS: {
      const { data } = action.payload;

      return {
        ...state,
        defaultTasks: data,
      };
    }

    case types.GET_TRANSACTION_STEPS: {
      const { data } = action.payload;

      return {
        ...state,
        steps: data,
      };
    }

    case types.GET_TRANSACTION_STEP_COMMENTS: {
      const { data } = action.payload;

      return {
        ...state,
        stepComments: data,
      };
    }

    case types.GET_TRANSACTION_STEPS_DOCUMENTS: {
      const { data } = action.payload;
      const documents = data.filter((item) => item.documentType === "Document");

      return {
        ...state,
        stepsDocuments: documents,
      };
    }

    case types.GET_TRANSACTION_TEMPLATES: {
      const { data } = action.payload;

      // filter out deleted templates and sort by stepId
      const filteredData = data
        .filter((d) => !d.isDeleted)
        .sort((a, b) => a.defaultStepId - b.defaultStepId);

      // place filteredData in a map with defaultStepId as the key so we can
      // sort by defaultTaskId next
      const map = {};
      filteredData.forEach(
        (template) =>
          (map[template.defaultStepId] = [
            ...(map[template.defaultStepId] || []),
            template,
          ])
      );

      // sort each list by defaultTaskId
      Object.values(map).forEach((v) =>
        v.sort((a, b) => a.defaultTaskId - b.defaultTaskId)
      );

      return {
        ...state,
        templates: Object.values(map).flat(),
      };
    }

    case types.UPDATE_TRANSACTION_TEMPLATE: {
      const { data } = action.payload;

      const updatedTemplates = state.templates.map((t) => {
        if (t.id === data.id) {
          return { ...t, ...data };
        } else return t;
      });

      return {
        ...state,
        templates: updatedTemplates,
      };
    }

    case types.DELETE_TRANSACTION_TEMPLATE: {
      const idToRemove = action.payload;
      return {
        ...state,
        templates: [...state.templates.filter((t) => t.id !== idToRemove)],
      };
    }

    case types.ADD_TRANSACTION_TEMPLATE: {
      const { data } = action.payload;

      return {
        ...state,
        templates: [data, ...state.templates],
      };
    }

    case types.GET_TRANSACTION_TASKS: {
      const { data } = action.payload;

      return {
        ...state,
        tasks: data,
      };
    }

    case types.GET_TRANSACTION_TASKS_UNCOMPLETED: {
      const { data } = action.payload;

      return {
        ...state,
        tasksUncompleted: data,
      };
    }

    case types.GET_TRANSACTION_FILTER_OPTIONS: {
      const { data } = action.payload;

      const {
        names,
        countries,
        stateProvinces,
        cities,
        transactionTypes,
        transactionManagers,
        transactionStatuses,
        businessUnits,
        transactionClientManagers,
        transactionUdfs
      } = data;

      return {
        ...state,
        names,
        cities,
        stateProvinces,
        countries,
        transactionTypes,
        transactionStatuses,
        transactionManagers,
        businessUnits,
        transactionClientManagers,
        transactionUdfs
      };
    }

    case types.GET_TRANSACTION_NAMES: {
      const { data } = action.payload;

      return {
        ...state,
        names: data,
      };
    }

    case types.GET_TRANSACTION_CITIES: {
      const { data } = action.payload;

      return {
        ...state,
        cities: data,
      };
    }

    case types.GET_TRANSACTION_STATE_PROVINCES: {
      const { data } = action.payload;

      return {
        ...state,
        stateProvinces: data,
      };
    }

    case types.GET_TRANSACTION_COUNTRIES: {
      const { data } = action.payload;

      return {
        ...state,
        countries: data,
      };
    }

    case types.GET_TRANSACTION_TYPES: {
      const { data } = action.payload;

      return {
        ...state,
        transactionTypes: data,
      };
    }

    case types.GET_TRANSACTION_TYPES_CUSTOM: {
      const { data } = action.payload;

      return {
        ...state,
        transactionTypesCustom: data,
      };
    }

    case types.ADD_TRANSACTION_TYPE_CUSTOM: {
      const { data } = action.payload;

      const { id, clientId, type, createdBy, createdDate } = data;

      const newType = {
        transactionTypeId: id,
        transactionType: type
      };

      let copy = [newType];

      if (state.transactionTypesCustom) {
        copy = [...copy, ...state.transactionTypesCustom];
      }

      return {
        ...state,
        transactionTypesCustom: copy,
      };
    }

    case types.UPDATE_TRANSACTION_TYPES_CUSTOM: {
      const { data } = action.payload;

      let copy = state.transactionTypesCustom ? [...state.transactionTypesCustom] : [];

      data.forEach((updatedType) => {
        const idx = copy.findIndex(
          (t) => t.transactionTypeId === updatedType.id
        );
        if (idx !== -1) {
          // If exists, update the data
          copy[idx] = {
            ...copy[idx],
            transactionTypeId: updatedType.id,
            transactionType: updatedType.type,
            // Optionally merge other fields if present in updatedType
            ...updatedType
          };
        } else {
          // If not exists, add the new type
          copy.push({
            transactionTypeId: updatedType.id,
            transactionType: updatedType.type,
            ...updatedType
          });
        }
      });

      return {
        ...state,
        transactionTypesCustom: copy,
      };
    }

    case types.DELETE_TRANSACTION_TYPE_CUSTOM: {
      const { id } = action.payload;

      return {
        ...state,
        transactionTypesCustom: [
          ...state.transactionTypesCustom.filter((t) => t.transactionTypeId !== id),
        ],
      };
    }

    case types.GET_TRANSACTION_STATUSES: {
      const { data } = action.payload;

      return {
        ...state,
        transactionStatuses: data,
      };
    }

    case types.GET_TRANSACTION_MANAGERS: {
      const { data } = action.payload;

      return {
        ...state,
        transactionManagers: data,
      };
    }

    case types.GET_TRANSACTION_BUSINESS_UNITS: {
      const { data } = action.payload;

      return {
        ...state,
        businessUnits: data,
      };
    }

    case types.SAVE_TRANSACTION: {
      const { data } = action.payload;

      return {
        ...state,
        details: { ...data, transactionId: data.id },
      };
    }

    case types.UPDATE_TRANSACTION: {
      const { data } = action.payload;

      return {
        ...state,
        details: { ...data, transactionId: data.id },
      };
    }

    case types.UPDATE_TRANSACTION_STEP_DATES: {
      const { data } = action.payload;

      return {
        ...state,
        details: {
          ...data.transaction,
          transactionId: data.transaction.id,
          transactionStatusName:
            transactionStatusNameMap[data.transaction.transactionStatusId],
          prevTransactionId: state.details?.prevTransactionId,
          prevTransactionName: state.details?.prevTransactionName,
          nextTransactionId: state.details?.nextTransactionId,
          nextTransactionName: state.details?.nextTransactionName,
        },
        steps: data.transactionSteps,
      };
    }

    case types.UPDATE_TRANSACTION_TASK: {
      const { data } = action.payload;

      return {
        ...state,
        tasks: data.transactionTasks,
        tasksUncompleted: data.uncompletedTasks,
      };
    }

    case types.UPDATE_TRANSACTION_STATUS: {
      const { data } = action.payload;

      return {
        ...state,
        details: {
          ...state.details,
          ...data,
          transactionStatusName:
            transactionStatusNameMap[data.transactionStatusId],
        },
      };
    }

    case types.UPDATE_TRANSACTION_UPLOAD_STATUS: {
      const { data } = action.payload;
      const { onHold, modifiedBy } = data;
      return {
        ...state,
        details: {
          ...state.details,
          onHold,
          modifiedBy,
        },
      };
    }

    case types.UPDATE_TRANSACTION_AT_RISK: {
      const { data } = action.payload;
      const { atRisk, modifiedBy, modifiedDate } = data;
      return {
        ...state,
        details: {
          ...state.details,
          atRisk,
          modifiedBy,
          modifiedDate,
        },
      };
    }

    case types.CANCEL_TRANSACTION: {
      const { data } = action.payload;

      return {
        ...state,
        details: { ...data, transactionId: data.id },
      };
    }

    // case types.ASSIGN_LEASE_EVENTS_TO_TRANSACTION: {
    //   const { data } = action.payload;

    //   return {
    //     ...state,
    //     associatedLeaseEvents: data,
    //   };
    // }

    // case types.ASSIGN_PRE_TRANSACTION_TO_TRANSACTION: {
    //   const { data } = action.payload;

    //   return {
    //     ...state,
    //     associatedPreTransaction: data,
    //   };
    // }

    // case types.ASSIGN_PROPERTIES_TO_TRANSACTION: {
    //   const { data } = action.payload;

    //   return {
    //     ...state,
    //     associatedProperties: data,
    //   };
    // }

    case types.UPDATE_TRANSACTION_COMMENT: {
      const { data } = action.payload;
      const updatedComments = {};

      data.forEach((c) => {
        updatedComments[c.commentId] = {
          commentId: c.commentId,
          comment: c.comment,
          taskId: c.taskId,
          stepId: c.stepId,
          transactionId: c.transactionId,
          commentedDate: c.commentedDate,
          commentBy: c.commentBy,
          taskName: state.tasks?.find((t) => t.taskId === c.taskId)?.taskName,
          stepName: state.steps?.find((s) => s.stepId === c.stepId)?.stepName,
          taggedUsers: c.taggedUsers,
        };
      });

      let copy = [];

      if (state.comments) {
        copy = [...state.comments];
      }

      const newComments = copy.map((c) =>
        updatedComments[c.commentId]
          ? { ...c, ...updatedComments[c.commentId] }
          : { ...c }
      );
      return {
        ...state,
        comments: newComments,
      };
    }

    case types.CREATE_TRANSACTION_COMMENT: {
      const { data } = action.payload;
      const {
        commentId,
        comment,
        taskId,
        stepId,
        transactionId,
        commentBy,
        commentedDate,
        taggedUsers,
      } = data;
      const newComment = {
        commentId: commentId,
        comment: comment,
        taskId: taskId,
        stepId: stepId,
        transactionId: transactionId,
        commentedDate: commentedDate,
        commentBy: commentBy,
        taskName: state.tasks.find((t) => t.taskId === taskId)?.taskName,
        stepName: state.steps.find((s) => s.stepId === stepId)?.stepName,
        taggedUsers: taggedUsers,
      };

      let copy = [newComment];

      if (state.comments) {
        copy = [...copy, ...state.comments];
      }

      return {
        ...state,
        comments: copy,
      };
    }

    case types.DELETE_TRANSACTION_COMMENT: {
      const { commentId } = action.payload;
      return {
        ...state,
        comments: [...state.comments.filter((c) => c.commentId !== commentId)],
      };
    }

    case types.GET_TRANSACTION_ASSOCIATED_LEASE_EVENTS: {
      const { data } = action.payload;

      return {
        ...state,
        associatedLeaseEvents: data,
      };
    }

    case types.GET_TRANSACTION_ASSOCIATED_PRE_TRANSACTION: {
      const { data } = action.payload;

      return {
        ...state,
        associatedPreTransaction: data,
      };
    }

    case types.GET_LAST_STEP_OF_PRE_TRANSACTION: {
      const { data } = action.payload;
      return {
        ...state,
        associatedPreTransaction: {
          ...state.associatedPreTransaction,
          lastStep: data,
        },
      };
    }

    case types.GET_TRANSACTION_ASSOCIATED_PROPERTIES: {
      const { data } = action.payload;

      return {
        ...state,
        associatedProperties: data,
      };
    }

    case types.GET_TRANSACTION_AUDITS: {
      const { data } = action.payload;
      return {
        ...state,
        audits: data,
      };
    }

    case types.RESET_TRANSACTION_COMMENTS: {
      return {
        ...state,
        comments: [],
      };
    }

    case types.RESET_PRE_TRANSACTION_ASSOCIATED: {
      return {
        ...state,
        associatedPreTransaction: {},
      };
    }

    case types.GET_ALL_TRANSACTIONS: {
      const { data } = action.payload;
      return {
        ...state,
        allTransactions: data,
      };
    }

    case types.DELETE_TRANSACTION: {
      const { data } = action.payload;
      return {
        ...state,
        allTransactions: data,
      };
    }

    case types.UNDELETE_TRANSACTION: {
      const { data } = action.payload;
      return {
        ...state,
        allTransactions: data,
      };
    }

    case types.GET_ADDRESS_DETAILS: {
      const { data } = action.payload;
      return {
        ...state,
        addressDetails: data,
      };
    }

    case types.GET_TRANSACTION_CLIENT_MANAGERS: {
      const { data } = action.payload;

      return {
        ...state,
        transactionClientManagers: data,
      };
    }

    case types.CLEAR_TRANSACTION_DETAILS: {
      return {
        ...state,
        details: {},
        comments: [],
        documents: [],
        defaultSteps: [],
        defaultTasks: [],
        steps: [],
        tasks: [],
        tasksUncompleted: [],
        stepComments: [],
        stepsDocuments: [],
        associatedLeaseEvents: [],
        associatedProperties: [],
        associatedPreTransaction: [],
      };
    }

    case types.GET_TRANSACTION_PAGE_SIZE: {
      const { data } = action.payload || {};
      return {
        ...state,
        transactionPageSize: data,
      };
    }

    case types.GET_TRANSACTION_BY_ID: {
      const { data } = action.payload;

      return {
        ...state,
        duplicateTransaction: data,
      };
    }

    case types.CLEAR_DUPLICATE_TRANSACTION: {
      return {
        ...state,
        duplicateTransaction: {},
        associatedLeaseEvents: [],
        associatedProperties: [],
        associatedPreTransaction: [],        
      };
    }

    case types.GET_TRANSACTION_ACTIVITY: {
      const { data } = action.payload;

      return {
        ...state,
        transactionActivity : data,
      };
    }

    case types.GET_TRANSACTION_APPROVERS: {
      const { data } = action.payload;

      return {
        ...state,
        transactionApprovers : data,
      };
    }

    case types.GET_SELECTED_APPROVERS: {
      const data = action.payload?.data || [];

      return {
        ...state,
        transactionSelectedApprovers : data,
      };
    }

    case types.GET_TRANSACTION_APPROVAL_CARD: {
      const { data } = action.payload;

      return {
        ...state,
        approvalCardData : data,
      };
    }

     case types.GET_TRANSACTION_APPROVAL_RESPONSE: {
      const data = action.payload?.data || [];

      return {
        ...state,
        transactionApprovalResponse : data,
      };
    }

    case types.GET_TRANSACTION_ALL_APPROVAL_RESPONSE: {
      const data = action.payload?.data || [];

      return {
        ...state,
        transactionAllApprovalResponse : data,
      };
    }

    case types.GET_TRANSACTION_APPROVAL_COMMENTS: {
      const data = action.payload?.data || [];
  
      return {
        ...state,
        transactionApprovalComments : data,
      };
    }
 
    case types.ADD_TRANSACTION_APPROVAL_RESPONSE: {
      const { data } = action.payload;

      return {
        ...state,
        transactionApprovalResponse : [...state.transactionApprovalResponse, data],
      };
    }

    case types.ADD_TRANSACTION_APPROVAL_DOCUMENT: {
      const { data } = action.payload;

      const prevDocs = Array.isArray(state.transactionApprovalDocuments) 
        ? state.transactionApprovalDocuments 
        : [];

      return {
        ...state,
        transactionApprovalDocuments : [...prevDocs, data],
      };
    }

    default:
      return state;
  }
}
